module.exports = __webpack_public_path__ + "static/media/hambalek.7f973a5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/hambalek.jpg
// module id = 495
// module chunks = 0